import { Button } from '@mui/material';
import Constants from '../../../constants';
import { DropResult } from 'react-beautiful-dnd';
import { FlipCardComponent } from '../../../models/LessonComponent';
import { FlipCardItem } from '../../../models/LessonComponentContent';
import { FlipItems } from './FlipItems';
import Grid from '@mui/material/Unstable_Grid2';
import ItemEditor from '../ItemEditor';
import NewComponentService from '../../../services/NewComponentService';
import React from 'react';
import { cloneDeep } from 'lodash';
import styles from '../../../styles/FlipCard.module.scss';
import { useLessonEditContext } from '../../../models/LessonEditContext';
import useThemes from '../../../../shared/hooks/useThemes';

export interface FlipCardEditorProps {
  component: FlipCardComponent;
}

export const FlipCardEdit = (props: FlipCardEditorProps) => {
  const flipCards: FlipCardItem[] = props.component?.content.flipCard;
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;
  const { handleSettingsChange } = useLessonEditContext();

  const handleSaveInstruction = (value: string) => {
    const copy = cloneDeep(props.component);
    copy.content.caption = value;
    handleSettingsChange(copy);
  };

  const handleItemChange = (card: FlipCardItem) => {
    const copy = cloneDeep(props.component);
    const index = copy.content.flipCard.findIndex((c) => c.id === card.id);
    copy.content.flipCard[index] = card;
    handleSettingsChange(copy);
  };

  const handleItemDelete = (id: string) => {
    const copy = cloneDeep(props.component);
    const index = copy.content.flipCard.findIndex((c) => c.id === id);
    copy.content.flipCard.splice(index, 1);
    handleSettingsChange(copy);
  };

  const handleAdd = () => {
    const newItem = NewComponentService.createFlipCard();
    const copy = cloneDeep(props.component);
    copy.content.flipCard.push(newItem);
    handleSettingsChange(copy);
  };

  const handleDragEnd = (result: DropResult) => {
    // prevent from destination index outbound error
    if (!result.destination) return;
    const fromIndex = result.source.index;
    const toIndex = result.destination.index;
    const copy = cloneDeep(props.component);
    const movingItem = copy.content.flipCard[fromIndex];
    copy.content.flipCard.splice(fromIndex, 1);
    copy.content.flipCard.splice(toIndex, 0, movingItem);
    handleSettingsChange(copy);
  };

  return (
    <>
      <Grid container direction="column" style={{ fontFamily }}>
        <Grid className={styles.instructionText}>
          <ItemEditor
            styleType="noList"
            componentkey={props.component?.componentkey}
            value={props.component.content?.caption || ''}
            placeholder={'Click to add instruction text'}
            isCenterAligned
            onChange={handleSaveInstruction}
          />
        </Grid>
        <Grid>
          <FlipItems
            flipCards={flipCards}
            componentkey={props.component?.componentkey}
            onItemChange={handleItemChange}
            onItemDelete={handleItemDelete}
            onDragEnd={handleDragEnd}
          />
          <Button
            onClick={handleAdd}
            disabled={flipCards.length >= Constants.FlipCardMaxNumItems}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
